
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"100","height":"120","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"4","y":"4","width":"92","height":"112","rx":"4","fill":"#fff"}}),_c('rect',{attrs:{"x":"2","y":"2","width":"96","height":"116","rx":"6","stroke":"#C2C2C2","stroke-opacity":".18","stroke-width":"4"}}),_c('rect',{attrs:{"x":"4","y":"4","width":"92","height":"112","rx":"4","fill":"#fff"}}),_c('rect',{attrs:{"x":"3","y":"3","width":"94","height":"114","rx":"5","stroke":"#C2C2C2","stroke-opacity":".18","stroke-width":"2"}}),_c('rect',{attrs:{"x":"3.5","y":"3.5","width":"93","height":"113","rx":"4.5","stroke":"#C2C2C2","stroke-opacity":".4"}}),_c('rect',{attrs:{"opacity":".98","x":"30","y":"76","width":"40","height":"12","rx":"6","fill":"#F39"}}),_c('rect',{attrs:{"opacity":".6","x":"14.75","y":"46.75","width":"70.5","height":"18.5","rx":"4.25","fill":"#9AA5BB","fill-opacity":".15","stroke":"#9AA5BB","stroke-width":"1.5"}}),_c('path',{attrs:{"opacity":".5","fill":"#9AA5BB","fill-opacity":".75","d":"M30 28h40v6H30z"}}),_c('circle',{attrs:{"cx":"32","cy":"56","r":"4","fill":"#7F8CA7"}}),_c('circle',{attrs:{"cx":"44","cy":"56","r":"4","fill":"#7F8CA7"}}),_c('circle',{attrs:{"cx":"56","cy":"56","r":"4","fill":"#7F8CA7"}}),_c('circle',{attrs:{"cx":"68","cy":"56","r":"4","fill":"#7F8CA7"}})])
          )
        }
      }
    